import { fetchEndpoint } from "../network";

/**
 * 标签管理 - 标签设置
 */

export default {
  // 列表
  list(params) {
    params.noShowLoading = true;
    return fetchEndpoint("/create-platform/tag/findTags", "POST", params);
  },
  //锁定
  lock(params) {
    return fetchEndpoint(
      "/create-platform/content/article/lock",
      "GET",
      params
    );
  },
  // 添加标签
  create(params) {
    return fetchEndpoint("/create-platform/tag/add", "GET", params);
  },

  // 修改标签
  edit(params) {
    return fetchEndpoint("/create-platform/tag/modify", "GET", params);
  },

  // 删除标签
  remove(params) {
    return fetchEndpoint("/create-platform/tag/removes", "POST", params);
  },
  detail(id) {
    return fetchEndpoint("/create-platform/tag/info", "GET", { id: id });
  },
};
